import { NavLink } from "react-router-dom";

export default function Nav() {
  const base =
    "relative group inline-flex items-center px-3 py-2 rounded-md " +
    "text-slate-700 hover:text-slate-900 " +
    "focus:outline-none focus-visible:ring-2 focus-visible:ring-blue-500/60";

  // Gradient underline via ::after
  const underline =
    "after:content-[''] after:absolute after:left-2 after:right-2 after:bottom-0 " +
    "after:h-[3px] after:rounded-full " +
    "after:bg-gradient-to-r after:from-red-600 after:via-white after:to-blue-600 " +
    "after:origin-left after:scale-x-0 group-hover:after:scale-x-100 " +
    "after:opacity-0 group-hover:after:opacity-100 " +
    "after:transition after:duration-300";

  // Active route keeps underline visible & boldens text
  const active = "text-slate-900 font-semibold after:scale-x-100 after:opacity-100";

  const links = [
    { to: "/", label: "Home", end: true },
    { to: "/companies", label: "Companies" },
  ];

  return (
    <nav className="flex flex-wrap items-center gap-2 mb-6">
      {links.map(({ to, label, end }) => (
        <NavLink
          key={to}
          to={to}
          end={end}
          className={({ isActive }) => `${base} ${underline} ${isActive ? active : ""}`}
        >
          {label}
        </NavLink>
      ))}
    </nav>
  );
}